import React from 'react';
import {
  Filter, TextInput,
} from 'react-admin';

const UsersFilter = props => (
  <Filter {...props}>
    <TextInput label="Search by username" source="q" alwaysOn />
  </Filter>
);

export default UsersFilter;
